import React, { FC, useContext, useEffect, useState } from 'react';
import { MediaUploaderDropPlace } from '../_DropPlace/UploaderDropPlace';
import { UploaderSingleFile } from './_SingleFile/UploaderSingleFile';
import { DropzoneState } from 'react-dropzone';
import { TMediaUploaderPreviewMode } from '../models';
import { IMediaImageResizeOption } from '@src/models/entity';
import { UploaderContext } from '../context';
import { ErrorBlock } from '../_ErrorBlock/ErrorBlock';

interface ISingleContainerProps {
  dropzone: DropzoneState;
  previewMode: TMediaUploaderPreviewMode;
  previewSize: IMediaImageResizeOption | undefined;
  isDropPlaceGrey: boolean | undefined;
  greyscale: boolean;
  showFileInfo: boolean;
  showDeleteButton: boolean;
  disabled: boolean;
  focus: boolean;
  maxFiles: number;
  maxFileSizeMB: number;
  acceptedFiles: string;
}

export const SingleContainer: FC<ISingleContainerProps> = ({
  dropzone,
  previewMode,
  previewSize,
  isDropPlaceGrey,
  greyscale,
  showFileInfo,
  showDeleteButton,
  disabled,
  focus,
  maxFiles,
  maxFileSizeMB,
  acceptedFiles,
}) => {
  const { controller, id } = useContext(UploaderContext);

  /**
   * Эта мапа не такая как в контроллере, т.к. так удобней парсить ошибки
   * здесь ключ - ошибка, значение - массив файлов */
  const [errorsMap, setErrorsMap] = useState(controller.errorsMap);

  useEffect(() => {
    controller.addErrorListener({
      listenerName: `_innerSingleContainerListener_${id}`,
      cb: setErrorsMap,
    });
  }, [controller, id]);

  if (controller.fileList[0]) {
    return (
      <>
        {Array.from(errorsMap).map(([errorCode, fileList]) => (
          <ErrorBlock
            key={errorCode}
            acceptedFiles={acceptedFiles}
            maxFileSizeMB={maxFileSizeMB}
            maxFiles={maxFiles}
            errorCode={errorCode}
            fileList={fileList}
          />
        ))}
        <UploaderSingleFile
          dropzone={dropzone}
          previewMode={previewMode}
          previewSize={previewSize}
          file={controller.fileList[0]}
          greyscale={greyscale}
          showFileInfo={showFileInfo}
          showDeleteButton={showDeleteButton}
          disabled={disabled}
          focus={focus}
        />
      </>
    );
  }

  return (
    <>
      {Array.from(errorsMap).map(([errorCode, fileList]) => (
        <ErrorBlock
          key={errorCode}
          acceptedFiles={acceptedFiles}
          maxFileSizeMB={maxFileSizeMB}
          maxFiles={maxFiles}
          errorCode={errorCode}
          fileList={fileList}
        />
      ))}
      <MediaUploaderDropPlace
        dropzone={dropzone}
        previewMode={previewMode}
        previewSize={previewSize}
        isDropPlaceGrey={isDropPlaceGrey}
        disabled={disabled}
        focus={focus}
      />
    </>
  );
};
